<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <el-breadcrumb separator="/" class="page-breadcrumb">
        <el-breadcrumb-item>
          <div class="breadcrumb">
            <div class="left"></div>
            <div class="right"><h2>公共账号</h2></div>
          </div>
        </el-breadcrumb-item>
      </el-breadcrumb>

      <div class="page-actions">
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-select
                v-model="filterUserType"
                placeholder="科目类型"
                clearable
                size="mini"
                style="width: 200px"
              >
                <el-option
                  v-for="item in typeOptions"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </div>
          </div>
          <div class="item">
            <el-button size="mini" type="primary" @click="handleSearch">查询</el-button>
          </div>
          <div class="item" v-if="$hasPerm('tenant:public_account:add')">
            <el-button size="mini" type="primary" @click="openCreate">新建</el-button>
          </div>
        </div>
      </div>

      <el-table :data="tableList" height="calc(100vh - 320px)" size="mini" v-loading="loading">
        <el-table-column prop="id" label="系统用户 ID" min-width="110" header-align="left" align="left" />
        <el-table-column prop="tenantUserId" label="租户用户 ID" min-width="110" header-align="left" align="left" />
        <el-table-column prop="userType" label="类型编码" width="90" header-align="left" align="left" />
        <el-table-column prop="userTypeName" label="科目名称" min-width="140" header-align="left" align="left" />
        <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip header-align="left" align="left" />
        <el-table-column prop="createTime" label="创建时间" min-width="160" header-align="left" align="left">
          <template slot-scope="scope">
            {{ scope.row.createTime | moment }}
          </template>
        </el-table-column>
      </el-table>

      <div class="pag">
        <pagination
          :size="pagination.size"
          :total="totalCount"
          :page="pagination.page"
          @pageChanged="pageChanged"
        />
      </div>

      <CreateDialog
        v-model="createVisible"
        :type-options="typeOptions"
        :existing-types="existingTypes"
        @success="onCreateSuccess"
      />
    </el-card>
  </div>
</template>

<script>
import Pagination from 'components/pagination';
import CreateDialog from './components/CreateDialog.vue';
import api from './api';

const PAGINATION = { page: 1, size: 20 };

export default {
  name: 'PublicAccountList',
  components: { Pagination, CreateDialog },
  data() {
    return {
      loading: false,
      filterUserType: null,
      typeOptions: [],
      tableList: [],
      totalCount: 0,
      pagination: { ...PAGINATION },
      createVisible: false,
      existingTypes: [],
    };
  },
  created() {
    this.loadTypes();
    this.fetchList();
  },
  methods: {
    loadTypes() {
      api.types().then((res) => {
        if (res && res.code === 0) {
          this.typeOptions = res.data || [];
        }
      });
    },
    handleSearch() {
      this.pagination.page = 1;
      this.fetchList();
    },
    pageChanged({ page, size }) {
      this.pagination = { page, size };
      this.fetchList();
    },
    fetchList() {
      this.loading = true;
      api
        .page({
          page: this.pagination.page,
          size: this.pagination.size,
          userType: this.filterUserType,
        })
        .then((res) => {
          if (res && res.code === 0) {
            const d = res.data || {};
            this.tableList = d.records || d.list || [];
            this.totalCount = d.total != null ? d.total : d.totalCount || 0;
          } else {
            this.tableList = [];
            this.totalCount = 0;
            this.$message.error((res && res.msg) || '查询失败');
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    refreshExistingTypes() {
      return api.page({ page: 1, size: 100 }).then((res) => {
        if (res && res.code === 0) {
          const d = res.data || {};
          const rows = d.records || d.list || [];
          this.existingTypes = rows.map((row) => row.userType);
        }
      });
    },
    openCreate() {
      this.refreshExistingTypes().finally(() => {
        this.createVisible = true;
      });
    },
    onCreateSuccess() {
      this.fetchList();
      this.refreshExistingTypes();
    },
  },
};
</script>

<style scoped>
.page-actions .select {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 8px;
}

.page-actions .item .ipt {
  min-width: 140px;
}
</style>
